<template>
  <el-dialog
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
             label-width="150px">
      <el-form-item label="职员代码" prop="zydm">
        <el-input  clearable v-model="dataForm.zydm" style="width: 60%;"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="zyxm">
        <el-input clearable v-model="dataForm.zyxm" style="width: 60%;"></el-input>
      </el-form-item>
      <el-form-item  label="组织单元" prop="zzdyid">
        <el-select clearable filterable  v-model="dataForm.zzdyid" style="width: 60%;">
          <el-option v-for="item in zzdyList" :key="item.bmid" :label="item.bmmc" :value="item.bmid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="福利类型" prop="zzdyid">
        <el-select clearable filterable  v-model="dataForm.fllxid" style="width: 60%;">
          <el-option v-for="item in fllxList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生日月份" prop="sryf">
        <el-input clearable v-model="dataForm.sryf" style="width: 60%;"></el-input>
      </el-form-item>
      <el-form-item label="金额" prop="je">
        <el-input clearable v-model="dataForm.je" style="width: 60%;"></el-input>
      </el-form-item>
      <el-form-item label="签收人" prop="qsr">
        <el-input clearable v-model="dataForm.qsr" style="width: 60%;"></el-input>
      </el-form-item>
      <el-form-item label="签收日期" prop="qsrq">
        <el-date-picker v-model="dataForm.qsrq" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 60%;"></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        if(value) {
          var patrn = /^\d+(\.\d+)?$/;
          if (!patrn.exec(value)) {
            callback(new Error('请填写数字'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        visible: false,
        dataForm: {
          id: '',
          zydm: '',
          zyxm:'',
          zzdyqc:'',
          zzdyid:'',
          fllxid:'',
          sryf:'',
          je:'',
          qsr:'',
          qsrq:''
        },
        zzdyList:[],
        fllxList:[],
        dataRule: {
          zydm: [
            {required: true, message: '请输入职员代码', trigger: 'blur'}
          ],
          zyxm: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          je:[
            {validator:validateNumber,trigger: 'blur'}
          ],
          qsrq: [
            {required: true, message: '请选择签收日期', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      init (id,zzdyList,fllxList) {
        this.zzdyList = zzdyList
        this.fllxList = fllxList
        this.dataForm.id = id
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if(this.dataForm.id) {
            this.$http({
              url: '/bjba/ygfl/findOneById/'+this.dataForm.id,
              method: 'get'
            }).then(({data}) => {
              this.dataForm = data.data
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.zzdyList.map(e => {
              if (e.bmid == this.dataForm.zzdyid) {
                this.dataForm.zzdyqc = e.bmmc
              }
            })
            this.$http({
              url: '/bjba/ygfl/save',
              method: 'post',
              data: this.dataForm
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else if(data && data.code === 500) {
                this.$message({
                  message: '操作失败',
                  type: 'error',
                  duration: 1500
                })
              }
            })
          }
        })
      }
    }
  }
</script>
